  class USSFProductCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.ussf-home-carousel__track');
    this.slides = Array.from(section.querySelectorAll('.ussf-home-carousel__slide'));
    this.prevBtn = section.querySelector('.ussf-home-carousel__arrow--prev');
    this.nextBtn = section.querySelector('.ussf-home-carousel__arrow--next');
    this.countEl = section.querySelector('.ussf-home-carousel__count');
    this.progressTrack = section.querySelector('.ussf-home-carousel__progress-track');

    if (!this.track || this.slides.length === 0) return;

    this.desktopGroupSize = parseInt(section.dataset.groupSize || '3', 10);
    this.breakpoint = 768;
    this.scrollTimeout = null;
    
    this.currentIndex = 0;
    this.isProgrammaticScroll = false;
    this.slideWidth = this.slides[0].offsetWidth;
    this.gap = this.getGap();

    // Initialize responsive group size
    this.updateGroupSize();
    
    // Generate initial pagination segments
    this.generatePaginationSegments();

    this.update();
    this.bindEvents();

    window.addEventListener('resize', () => this.onResize());
  }

  getGap() {
    const styles = window.getComputedStyle(this.track);
    return parseInt(styles.gap || styles.columnGap || 0, 10);
  }

  // Determine if we're on desktop (above breakpoint)
  isDesktop() {
    return window.innerWidth >= this.breakpoint;
  }

  // Update group size based on viewport
  updateGroupSize() {
    this.groupSize = this.isDesktop() ? this.desktopGroupSize : 1;
    this.totalGroups = Math.ceil(this.slides.length / this.groupSize);
  }

  // Generate pagination segments based on total groups
  generatePaginationSegments() {
    if (!this.progressTrack) return;

    // Clear existing segments
    this.progressTrack.innerHTML = '';

    // Create segments for each group
    for (let i = 0; i < this.totalGroups; i++) {
      const segment = document.createElement('span');
      segment.className = 'ussf-home-carousel__progress-segment';
      if (i === 0) {
        segment.classList.add('is-active');
      }
      this.progressTrack.appendChild(segment);
    }

    // Update segments reference
    this.segments = Array.from(
      this.progressTrack.querySelectorAll('.ussf-home-carousel__progress-segment')
    );
  }

  bindEvents() {
    this.nextBtn?.addEventListener('click', () => this.goNext());
    this.prevBtn?.addEventListener('click', () => this.goPrev());

    this.track.addEventListener(
      'scroll',
      () => this.onScroll(),
      { passive: true }
    );
  }

  onResize() {
    const wasDesktop = this.groupSize === this.desktopGroupSize;
    const isNowDesktop = this.isDesktop();
    
    // Update slide dimensions
    this.slideWidth = this.slides[0].offsetWidth;
    this.gap = this.getGap();
    
    // Check if viewport crossed the breakpoint
    if (wasDesktop !== isNowDesktop) {
      this.updateGroupSize();
      
      // Regenerate pagination segments for new group count
      this.generatePaginationSegments();
      
      // Snap to the nearest group boundary based on current position
      const currentGroup = this.getCurrentGroup();
      this.currentIndex = this.getGroupStartIndex(currentGroup);
      
      // Scroll to the new position without animation
      const x = this.currentIndex * (this.slideWidth + this.gap);
      this.track.scrollTo({ left: x, behavior: 'auto' });
    }
    
    this.update();
  }

  // Get the current group index based on slide index
  getCurrentGroup() {
    return Math.floor(this.currentIndex / this.groupSize);
  }

  // Get the starting slide index for a group
  getGroupStartIndex(groupIndex) {
    return groupIndex * this.groupSize;
  }

  goNext() {
    const currentGroup = this.getCurrentGroup();
    
    if (currentGroup < this.totalGroups - 1) {
      // Move to the start of the next group
      this.currentIndex = this.getGroupStartIndex(currentGroup + 1);
      this.scrollToIndex();
    }
  }

  goPrev() {
    const currentGroup = this.getCurrentGroup();
    
    if (currentGroup > 0) {
      // Move to the start of the previous group
      this.currentIndex = this.getGroupStartIndex(currentGroup - 1);
      this.scrollToIndex();
    }
  }

scrollToIndex() {
  this.isProgrammaticScroll = true;

  const x = this.currentIndex * (this.slideWidth + this.gap);
  this.track.scrollTo({ left: x, behavior: 'smooth' });

  this.update();

  // Clear any existing timeout
  if (this.scrollTimeout) {
    clearTimeout(this.scrollTimeout);
  }

  // Wait longer for smooth scroll to complete
  this.scrollTimeout = setTimeout(() => {
    this.isProgrammaticScroll = false;
  }, 600); // Generous timeout to ensure smooth scroll completes
}

onScroll() {
  if (this.isProgrammaticScroll) return;

  const scrollLeft = this.track.scrollLeft;
  const maxScroll = this.track.scrollWidth - this.track.clientWidth;
  
  // Calculate the current index with edge case handling
  let index;
  
  if (scrollLeft >= maxScroll - 5) {
    // At the end - set to last slide
    index = this.slides.length - 1;
  } else if (scrollLeft <= 5) {
    // At the beginning
    index = 0;
  } else {
    // Normal calculation
    index = Math.round(scrollLeft / (this.slideWidth + this.gap));
    // Clamp to valid range
    index = Math.max(0, Math.min(index, this.slides.length - 1));
  }

  if (index !== this.currentIndex) {
    this.currentIndex = index;
    this.update();
  }
}

  update() {
    const currentGroup = this.getCurrentGroup();
    
    if (this.countEl) {
      // Show group progress
      this.countEl.textContent = `${currentGroup + 1}/${this.totalGroups}`;
    }

    // Update progress segments based on groups
    this.segments.forEach((seg, i) => {
      seg.classList.toggle('is-active', i === currentGroup);
    });

    // Disable buttons at group boundaries
    this.prevBtn?.toggleAttribute('disabled', currentGroup === 0);
    this.nextBtn?.toggleAttribute(
      'disabled',
      currentGroup === this.totalGroups - 1
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.ussf-home-carousel')
    .forEach(section => new USSFProductCarousel(section));
});